import { useEffect } from 'react';
import usePrevious from 'hooks/use-previous-state';

import analyticsInstance from 'utils/analytics';

const useAnalyticsPopup = (isOpen, popupId) => {
  const prevOpen = usePrevious(isOpen);

  useEffect(() => {
    if (isOpen) {
      analyticsInstance.pushEvent({
        event: 'popup_visible',
        popup_id: popupId,
      });
    }

    if (prevOpen && !isOpen) {
      analyticsInstance.pushEvent({
        event: 'popup_close',
        popup_id: popupId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, popupId]);
};

export default useAnalyticsPopup;
